export enum DtwinsMetricsCertificateKey {
  EXPIRED = "expired",
  LESS_THAN_ONE_MONTH = "lessThanOneMonth",
  LESS_THAN_THREE_MONTHS = "lessThanThreeMonths",
  LESS_THAN_SIX_MONTHS = "lessThanSixMonths",
  MORE_THAN_SIX_MONTHS = "moreThanSixMonths",
}
